import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoSecciones from './components/ListadoSecciones';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allSeccionesAction,
  setActivoSeccionesAction,
} from './SeccionesAction';
import FormSecciones from './components/FormSecciones';
import { ModalComponent } from '../../../widgets';

const SeccionesView = () => {
  const dispatch = Redux.useDispatch();

  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoSeccionesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
        />
        <BotonComponent
          click={async () => {
            await setActivoSeccionesAction(dispatch, null);
            await allSeccionesAction(dispatch, seccionesStore.params);
          }}
          disabled={
            seccionesStore.all.length === 0 || seccionesStore.loadingAll
          }
          white
          refreshIcon
          text={seccionesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoSecciones setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormSecciones"
        title={`${
          seccionesStore.activo
            ? `Editar ${seccionesStore.activo.nombre}-${seccionesStore.activo.nivelAcademico.nivelAcademico.nombre}`
            : 'Nueva sección'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormSecciones
          activo={seccionesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default SeccionesView;
